import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { user } from 'services/user';
import { socket } from 'api';
import { Limiter, LimiterItem, ToggleWrapper, NumberBox } from './control-plate.styled';

export const ControlPlate = ({ sendControlMsg, limitEnabled, limitValue }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const vehicle_plate_control = user.getInterfaceParam('vehicle_plate_control');
  const disabled = vehicle_plate_control === false;
  // console.log("vehicle_plate_control", typeof vehicle_plate_control);

  useEffect(() => {
    const setLoadingOff = () => {
      setTimeout(() => setLoading(false), 250);
    };

    const updateSocketState = () => {
      sendControlMsg('get_state');
    };

    if (!disabled) {
      socket.on('settings.set_vehicle_plate_check', updateSocketState);
      socket.on('get_state', setLoadingOff);
    }

    return () => {
      if (!disabled) {
        socket.off('settings.set_vehicle_plate_check', updateSocketState);
        socket.off('get_state', setLoadingOff);
      }
    };
  }, [disabled]);

  /**
   * select input content
   * @param {*} event
   */
  const selectAll = (event) => {
    event.target.select();
  };

  /**
   * change enabled
   * @param {*} event
   */
  const setLimitEnabled = (event) => {
    const val = event.target.checked;
    setLoading(true);
    sendControlMsg('settings.set_vehicle_plate_check', { enable: val, distance: limitValue });
  };

  /**
   * change value
   * @param {*} event
   * @returns
   */
  const setLimitValue = (event) => {
    let val = parseInt(event.target.value, 0);
    if (val < 0) {
      val = 0;
    }
    if (val > 9) {
      val = 9;
    }
    if (isNaN(val)) {
      return;
    }
    setLoading(true);
    sendControlMsg('settings.set_vehicle_plate_check', { enable: limitEnabled, distance: val });
  };

  /**
   * apply a clamped value (used by the stepper buttons)
   */
  const applyValue = (v) => {
    let val = v;
    if (val < 0) val = 0;
    if (val > 9) val = 9;
    setLoading(true);
    sendControlMsg('settings.set_vehicle_plate_check', { enable: limitEnabled, distance: val });
  };

  const inc = () => applyValue((parseInt(limitValue, 10) || 0) + 1);
  const dec = () => applyValue((parseInt(limitValue, 10) || 0) - 1);

  if (disabled) {
    return null;
  }

  return (
    <Limiter $loading={loading}>
      <ToggleWrapper>
        <label>
          <input type="checkbox" className="toggle-input" checked={limitEnabled} onChange={setLimitEnabled} />
          <span className="toggle-slider" />
          <span className="label-text">{t('buttons.Контроль ГРЗ')}</span>
        </label>
      </ToggleWrapper>

      {limitEnabled && (
        <LimiterItem>
          <label className="left-side" htmlFor="limitValue">
            {t('windows.Расхождение, символов')}
          </label>
          <NumberBox>
            <input onFocus={selectAll} min={0} max={9} type="number" id="limitValue" value={limitValue} onChange={setLimitValue} />
            <div className="steps">
              <button type="button" aria-label="+" onClick={inc}>
                <svg viewBox="0 0 12 12" fill="none">
                  <path d="M3 7.5L6 4.5L9 7.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
              <button type="button" aria-label="-" onClick={dec}>
                <svg viewBox="0 0 12 12" fill="none">
                  <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </button>
            </div>
          </NumberBox>
        </LimiterItem>
      )}
    </Limiter>
  );
};
